import {ComponentType} from '@angular/cdk/portal';
import {Injectable, TemplateRef} from '@angular/core';
import {MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {New} from '@js-dot/core';
import {DotFormInterface} from '@ng-dot/form';
import {ConfirmDialogComponent, ConfirmDialogData} from './confirm-dialog.component';
import {DialogText} from './dialog-text';
import {FormDialogComponent} from './form-dialog.component';
import {FormDialogData} from './types';

const IDENTIABLE = ['subject', 'title', 'name', 'id'];

@Injectable({
	providedIn: 'root'
})
/**
 * 대화상자 서비스
 */
export class DialogService {
	constructor(
		protected _dialog: MatDialog,
		protected _text: DialogText
	) {
	}

	/**
	 * 대화 상자 열기
	 * @param component_or_templateRef
	 * @param config
	 */
	open<T, D = any>(component_or_templateRef: New<T> | TemplateRef<T>,
					 config?: MatDialogConfig<D>): MatDialogRef<T, D> {
		return this._dialog.open(component_or_templateRef, config);
	}

	/**
	 * __폼__ 대화 상자 열기
	 * @param data
	 */
	form(data: FormDialogData) {
		return this._dialog.open(FormDialogComponent, {data});
	}

	/**
	 * 생성 대화 상자 설탕
	 * @param form
	 * @param target
	 * @param component
	 * @param id
	 */
	create({
			   form,
			   target,
			   component,
			   id
		   }: {
		form: DotFormInterface,
		target?: string,
		component?: ComponentType<FormDialogComponent>,
		onSubmit?: Function,
		id?: string
	}): MatDialogRef<FormDialogComponent, FormDialogData>;

	/**
	 * __생성 폼__ 대화 상자 열기
	 * @param form
	 * @param component
	 * @param target
	 * @param onSubmit
	 * @param id
	 */
	create({
			   form,
			   component = FormDialogComponent,
			   target = null,
			   onSubmit = null,
			   id = null
		   }) {
		const {_text} = this;
		return this._dialog.open(
			component,
			{
				...(id && {id}),
				data: target ?
					{
						title: _text.get('$createTitle', target),
						description: _text.get('$createDescription', target),
						form,
						onSubmit
					} :
					{
						title: _text.get('createTitle'),
						description: _text.get('createDescription'),
						form,
						onSubmit
					}

			}
		);
	}

	/**
	 * __수정 폼__ 대화 상자 설탕
	 * @param form
	 * @param component
	 * @param target
	 * @param onSubmit
	 * @param values
	 * @param id
	 */
	update({
			   form,
			   component = FormDialogComponent,
			   target = null,
			   onSubmit = null,
			   values = null,
			   id = null
		   }: {
		form: DotFormInterface,
		component?: typeof FormDialogComponent,
		target?: string,
		onSubmit?: Function,
		values?: {},
		id?: string
	}) {
		const {_text} = this;

		form.asUpdate(values);

		let identifiedTarget;

		if (values) {
			IDENTIABLE.some(property => {
				if (values.hasOwnProperty(property)) {
					identifiedTarget = this._text.select(values, property);
					return true;
				}
				return false;
			});
		}

		return this._dialog.open(
			component,
			{
				...(id && {id}),
				data: identifiedTarget ?
					{
						title: _text.get('$updateTitle', identifiedTarget),
						description: typeof target === 'string' ?
							_text.get('$updateDescription', target) :
							_text.get('updateDescription'),
						form,
						onSubmit
					} :
					{
						title: _text.get('updateTitle'),
						description: _text.get('updateDescription'),
						form,
						onSubmit
					}
			}
		);
	}

	/**
	 * __확인__ 대화상자 설탕
	 * @param data
	 */
	confirm(data: ConfirmDialogData) {
		return this._dialog.open(ConfirmDialogComponent, {
			data
		});
	}

	/**
	 * __삭제 확인__ 대화상자 설탕
	 * @param ok
	 * @param target
	 * @param content
	 */
	confirmDelete(ok: () => void, target?: string, content?: string) {
		const {_text} = this;

		if (target) {
			const values = {target: target, content: content || target};
			return this.confirm({
				title: _text.get('$deleteConfirmTitle', values),
				message: _text.get('$deleteConfirmMessage', values),
				onOk: ok
			});
		}
		return this.confirm({
			title: _text.get('deleteConfirmTitle'),
			message: _text.get('deleteConfirmMessage'),
			onOk: ok
		});
	}

	/**
	 * __다중 삭제 확인__ 대화상자 설탕
	 * @param ok
	 * @param target
	 * @param content
	 */
	confirmDeletes(ok: () => void, target?: string, content?: string) {
		const {_text} = this;

		if (target) {
			const values = {target: target, content: content || target};
			return this.confirm({
				title: _text.get('$deleteConfirmTitle', values),
				message: _text.get('$deleteConfirmMessage', values),
				onOk: ok
			});
		}
		return this.confirm({
			title: _text.get('deletesConfirmTitle'),
			message: _text.get('deletesConfirmMessage'),
			onOk: ok
		});
	}
}

